import { Component } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent {

  searchText = "";
  searchItems: string[] = ['Item 1', 'Item 2', 'Item 3'];

  showSearchResults: boolean = true;

  onSearchChange(event: Event): void {
    this.searchText = (event.target as HTMLInputElement).value;
    console.log(this.searchText);

    if(this.searchText.length > 0)
    {
      console.log("Show search results");
      this.showSearchResults = true;
    }
    else
    {
      console.log("Hide search results");
      this.showSearchResults = false;
    }
  }
}
